import { bounceIn, fadeIn, flipInX, flipInY, jello, pulse, shake, swing, tada, zoomIn } from 'react-animations';
import styled, { css, keyframes } from 'styled-components';

import { SHAPE } from '../utils/constants.js';
import { getHeightPostLayout } from '../utils/functions.js';

const pulseAnimation = keyframes`${pulse}`;
const shakeAnimation = keyframes`${shake}`;
const tadaAnimation = keyframes`${tada}`;
const bounceInAnimation = keyframes`${bounceIn}`;
const fadeInAnimation = keyframes`${fadeIn}`;
const flipInXAnimation = keyframes`${flipInX}`;
const flipInYAnimation = keyframes`${flipInY}`;
const zoomInAnimation = keyframes`${zoomIn}`;
const swingAnimation = keyframes`${swing}`;
const jelloAnimation = keyframes`${jello}`;

const glowing = keyframes`
  0% {
    background-position: 0 0
}

  50% {
    background-position: 400% 0
}

  100% {
    background-position: 0 0
}
`;

// const bgMove = keyframes`
//   0% {
//     background-position: -500px 0;
//   }
//   100% {
//     background-position: 1000px 0;
//   }
// `;

const bgMove = keyframes`
  0%, 20% { /* Анімація швидко прокручується на початку */
    background-position: -500px 0;
  }
  95%, 100% { /* Анімація швидко прокручується на кінці */
    background-position: 1000px 0;
  }
`;

export const blinkStyles = css`
  background-image: linear-gradient(270deg, rgba(100, 181, 239, 0) 48.44%, #ffffff 75.52%, rgba(100, 181, 239, 0) 100%);
  background-repeat: no-repeat;
  animation: ${bgMove} linear 5s infinite;
`;

export const Beat = styled.div`
  position: relative;

  &:before {
    position: absolute;
    border-radius: 8px;
    top: 0;
    left: 0;
    z-index: 10000;
    width: 100%;
    height: 100%;
    content: '';

    ${(props) =>
      props.rgbColor &&
      css`
        animation: 5s ${keyframes`
      0% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(${props.rgbColor?.r}, ${props.rgbColor?.g}, ${props.rgbColor?.b}, 0.7);
      }

      70% {
        transform: scale(1);
        box-shadow: 0 0 0 10px rgba(${props.rgbColor?.r}, ${props.rgbColor?.g}, ${props.rgbColor?.b}, 0);
      }

      100% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(${props.rgbColor?.r}, ${props.rgbColor?.g}, ${props.rgbColor?.b}, 0);
      }`};
      `}

    animation-iteration-count: infinite;

    ${({ shape }) =>
      shape === SHAPE.square &&
      css`
        border-radius: 2px !important;
      `}

    ${({ shape }) =>
      shape === SHAPE.round &&
      css`
        border-radius: 36px !important;
      `}
  }
`;

export const Blink = css`
  &:before {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10000;
    width: 100%;
    height: 100%;
    content: '';
    background-image: linear-gradient(270deg, rgba(100, 181, 239, 0) 48.44%, #ffffff 75.52%, rgba(100, 181, 239, 0) 100%);
    background-repeat: no-repeat;
    animation: ${bgMove} linear 4s infinite;
  }
`;

const borderFlowKeyframe = keyframes`
  to { --bf-angle: 360deg; }
`;

export const BorderFlow = css`
  &:after {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: inherit;
    padding: 1.5px;
    background: conic-gradient(
      from var(--bf-angle),
      color-mix(in srgb, var(--ab-color, #ff9000) 30%, transparent) 0deg,
      color-mix(in srgb, var(--ab-color, #ff9000) 30%, transparent) 200deg,
      color-mix(in srgb, var(--ab-color, #ff9000) 60%, transparent) 280deg,
      var(--ab-color, #ff9000) 330deg,
      color-mix(in srgb, var(--ab-color, #ff9000) 60%, #ffffff) 352deg,
      color-mix(in srgb, var(--ab-color, #ff9000) 75%, transparent) 360deg
    );
    -webkit-mask:
      linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    animation: ${borderFlowKeyframe} 4s linear infinite;
    z-index: 10000;
    pointer-events: none;
  }
`;

export const Pulse = styled.div`
  width: 100%;
  animation: 5s ${pulseAnimation};
  animation-iteration-count: infinite;

  ${(props) =>
    props.display &&
    css`
      display: ${props.display};
    `}

  ${(props) =>
    props.mobileView === 1 &&
    css`
      width: calc(33.3% - 6px);
      margin-right: 8px;

      &:nth-child(3n + 3) {
        margin-right: 0;
      }
    `}
    
    ${(props) =>
    props.mobileView === 2 &&
    css`
      width: calc(50% - 8px);

      @media (max-width: 797px) {
        width: calc(50% - 4px);
      }
    `}

    ${(props) =>
    props.mobileView === 7 &&
    css`
      width: calc(50% - 8px);
      //height: 300px;

      @media (max-width: 797px) {
        width: calc(50% - 4px);
        //height: 400px;
      }
    `}

    ${(props) =>
    props.mobileView === 6 &&
    css`
      width: 100%;
    `}
`;

export const Shake = styled.div`
  width: 100%;
  animation: 5s ${shakeAnimation};
  animation-iteration-count: infinite;

  ${(props) =>
    props.display &&
    css`
      display: ${props.display};
    `}

  ${(props) =>
    props.mobileView === 1 &&
    css`
      width: calc(33.3% - 6px);
      margin-right: 8px;

      &:nth-child(3n + 3) {
        margin-right: 0;
      }
    `}

    ${(props) =>
    props.mobileView === 2 &&
    css`
      width: calc(50% - 8px);

      @media (max-width: 797px) {
        width: calc(50% - 4px);
      }
    `}

    ${(props) =>
    props.mobileView === 7 &&
    css`
      width: calc(50% - 8px);
      //height: 400px;

      @media (max-width: 797px) {
        width: calc(50% - 4px);
        //height: 300px;
      }
    `}

    ${(props) =>
    props.mobileView === 6 &&
    css`
      width: 100%;
    `}
`;

export const Tada = styled.div`
  width: 100%;
  animation: 5s ${tadaAnimation};
  animation-iteration-count: infinite;

  ${(props) =>
    props.display &&
    css`
      display: ${props.display};
    `}

  ${(props) =>
    props.mobileView === 1 &&
    css`
      width: calc(33.3% - 6px);
      margin-right: 8px;

      &:nth-child(3n + 3) {
        margin-right: 0;
      }
    `}

    ${(props) =>
    props.mobileView === 2 &&
    css`
      width: calc(50% - 8px);

      @media (max-width: 797px) {
        width: calc(50% - 4px);
      }
    `}

    ${(props) =>
    props.mobileView === 7 &&
    css`
      width: calc(50% - 8px);
      //height: 400px;

      @media (max-width: 797px) {
        width: calc(50% - 4px);
        //height: 300px;
      }
    `}

    ${(props) =>
    props.mobileView === 6 &&
    css`
      width: 100%;
    `}
`;

export const BounceIn = styled.div`
  width: 100%;
  animation: 5s ${bounceInAnimation};
  animation-iteration-count: infinite;

  ${(props) =>
    props.display &&
    css`
      display: ${props.display};
    `}

  ${(props) =>
    props.mobileView === 1 &&
    css`
      width: calc(33.3% - 6px);
      margin-right: 8px;

      &:nth-child(3n + 3) {
        margin-right: 0;
      }
    `}

    ${(props) =>
    props.mobileView === 2 &&
    css`
      width: calc(50% - 8px);

      @media (max-width: 797px) {
        width: calc(50% - 4px);
      }
    `}

    ${(props) =>
    props.mobileView === 7 &&
    css`
      width: calc(50% - 8px);
      //height: 400px;

      @media (max-width: 797px) {
        width: calc(50% - 4px);
        //height: 300px;
      }
    `}

    ${(props) =>
    props.mobileView === 6 &&
    css`
      width: 100%;
    `}
`;

export const FadeIn = styled.div`
  width: 100%;
  animation: 5s ${fadeInAnimation};
  animation-iteration-count: infinite;

  ${(props) =>
    props.display &&
    css`
      display: ${props.display};
    `}

  ${(props) =>
    props.mobileView === 1 &&
    css`
      width: calc(33.3% - 6px);
      margin-right: 8px;

      &:nth-child(3n + 3) {
        margin-right: 0;
      }
    `}

    ${(props) =>
    props.mobileView === 2 &&
    css`
      width: calc(50% - 8px);

      @media (max-width: 797px) {
        width: calc(50% - 4px);
      }
    `}

    ${(props) =>
    props.mobileView === 7 &&
    css`
      width: calc(50% - 8px);
      //height: 400px;

      @media (max-width: 797px) {
        width: calc(50% - 4px);
        //height: 300px;
      }
    `}

    ${(props) =>
    props.mobileView === 6 &&
    css`
      width: 100%;
    `}
`;

export const FlipInX = styled.div`
  width: 100%;
  animation: 5s ${flipInXAnimation};
  animation-iteration-count: infinite;

  ${(props) =>
    props.display &&
    css`
      display: ${props.display};
    `}

  ${(props) =>
    props.mobileView === 1 &&
    css`
      width: calc(33.3% - 6px);
      margin-right: 8px;

      &:nth-child(3n + 3) {
        margin-right: 0;
      }
    `}

    ${(props) =>
    props.mobileView === 2 &&
    css`
      width: calc(50% - 8px);

      @media (max-width: 797px) {
        width: calc(50% - 4px);
      }
    `}

    ${(props) =>
    props.mobileView === 7 &&
    css`
      width: calc(50% - 8px);
      //height: 400px;

      @media (max-width: 797px) {
        width: calc(50% - 4px);
        //height: 300px;
      }
    `}

    ${(props) =>
    props.mobileView === 6 &&
    css`
      width: 100%;
    `}
`;

export const FlipInY = styled.div`
  width: 100%;
  animation: 5s ${flipInYAnimation};
  animation-iteration-count: infinite;

  ${(props) =>
    props.display &&
    css`
      display: ${props.display};
    `}

  ${(props) =>
    props.mobileView === 1 &&
    css`
      width: calc(33.3% - 6px);
      margin-right: 8px;

      &:nth-child(3n + 3) {
        margin-right: 0;
      }
    `}

    ${(props) =>
    props.mobileView === 2 &&
    css`
      width: calc(50% - 8px);

      @media (max-width: 797px) {
        width: calc(50% - 4px);
      }
    `}

    ${(props) =>
    props.mobileView === 7 &&
    css`
      width: calc(50% - 8px);
      //height: 400px;

      @media (max-width: 797px) {
        width: calc(50% - 4px);
        //height: 300px;
      }
    `}

    ${(props) =>
    props.mobileView === 6 &&
    css`
      width: 100%;
    `}
`;

export const ZoomIn = styled.div`
  width: 100%;
  animation: 5s ${zoomInAnimation};
  animation-iteration-count: infinite;

  ${(props) =>
    props.display &&
    css`
      display: ${props.display};
    `}

  ${(props) =>
    props.mobileView === 1 &&
    css`
      width: calc(33.3% - 6px);
      margin-right: 8px;

      &:nth-child(3n + 3) {
        margin-right: 0;
      }
    `}

    ${(props) =>
    props.mobileView === 2 &&
    css`
      width: calc(50% - 8px);

      @media (max-width: 797px) {
        width: calc(50% - 4px);
      }
    `}

    ${(props) =>
    props.mobileView === 7 &&
    css`
      width: calc(50% - 8px);
      //height: 400px;

      @media (max-width: 797px) {
        width: calc(50% - 4px);
        //height: 300px;
      }
    `}

    ${(props) =>
    props.mobileView === 6 &&
    css`
      width: 100%;
    `}
`;

export const Swing = styled.div`
  width: 100%;
  animation: 5s ${swingAnimation};
  animation-iteration-count: infinite;

  ${(props) =>
    props.display &&
    css`
      display: ${props.display};
    `}

  ${(props) =>
    props.mobileView === 1 &&
    css`
      width: calc(33.3% - 6px);
      margin-right: 8px;

      &:nth-child(3n + 3) {
        margin-right: 0;
      }
    `}
    

    ${(props) =>
    props.mobileView === 2 &&
    css`
      width: calc(50% - 8px);

      @media (max-width: 797px) {
        width: calc(50% - 4px);
      }
    `}

    ${(props) =>
    props.mobileView === 7 &&
    css`
      width: calc(50% - 8px);
      //height: 400px;

      @media (max-width: 797px) {
        width: calc(50% - 4px);
        //height: 300px;
      }
    `}

    ${(props) =>
    props.mobileView === 6 &&
    css`
      width: 100%;
    `}
`;

export const Jello = styled.div`
  width: 100%;
  animation: 5s ${jelloAnimation};
  animation-iteration-count: infinite;

  ${(props) =>
    props.display &&
    css`
      display: ${props.display};
    `}

  ${(props) =>
    props.mobileView === 1 &&
    css`
      width: calc(33.3% - 6px);
      margin-right: 8px;

      &:nth-child(3n + 3) {
        margin-right: 0;
      }
    `}

    ${(props) =>
    props.mobileView === 2 &&
    css`
      width: calc(50% - 8px);

      @media (max-width: 797px) {
        width: calc(50% - 4px);
      }
    `}

    ${(props) =>
    props.mobileView === 7 &&
    css`
      width: calc(50% - 8px);
      //height: 400px;

      @media (max-width: 797px) {
        width: calc(50% - 4px);
        //height: 300px;
      }
    `}

    ${(props) =>
    props.mobileView === 6 &&
    css`
      width: 100%;
    `}
`;

export const NoAnimate = styled.div`
  width: 100%;

  ${(props) =>
    props.mobileView === 1 &&
    css`
      width: calc(33.3% - 6px);
      margin-right: 8px;

      &:nth-child(3n + 3) {
        margin-right: 0;
      }
    `}

  ${(props) =>
    props.mobileView === 2 &&
    css`
      width: calc(50% - 8px);

      @media (max-width: 797px) {
        width: calc(50% - 8px);
      }
    `}

    ${(props) =>
    props.mobileView === 7 &&
    css`
      width: calc(50% - 8px);

      @media (max-width: 797px) {
        width: calc(50% - 4px);
      }
    `}

    ${(props) =>
    props.mobileView === 8 &&
    props.viewType === 'slider' &&
    css`
      width: 115px;
      height: ${115 + getHeightPostLayout(props.postLayout)}px;

      img {
        object-fit: cover;
        height: 115px !important;
      }

      @media (max-width: 797px) {
        img {
          object-fit: cover;
          height: 115px !important;
        }

        width: 115px;
        height: ${115 + getHeightPostLayout(props.postLayout)}px;
      }
    `}


    ${(props) =>
    props.mobileView === 2 &&
    props.viewType === 'slider' &&
    css`
      width: 180px;
      height: ${180 + getHeightPostLayout(props.postLayout)}px;

      img {
        object-fit: cover;
        height: 180px !important;
      }

      @media (max-width: 797px) {
        img {
          object-fit: cover;
          height: 180px !important;
        }

        width: 180px;
        height: ${180 + getHeightPostLayout(props.postLayout)}px;
      }
    `}

    ${(props) =>
    props.mobileView === 4 &&
    props.viewType === 'slider' &&
    css`
      width: 300px;
      height: ${350 + getHeightPostLayout(props.postLayout)}px;

      img {
        object-fit: cover;
        height: 350px !important;
      }

      @media (max-width: 797px) {
        img {
          object-fit: cover;
          height: 350px !important;
        }

        width: 300px;
        height: ${350 + getHeightPostLayout(props.postLayout)}px;
      }
    `}

    ${(props) =>
    props.mobileView === 7 &&
    props.viewType === 'slider' &&
    css`
      width: 180px;

      img {
        object-fit: cover;
      }

      @media (max-width: 797px) {
        img {
          object-fit: cover;
        }

        width: 180px;
      }
    `}
`;
